import { sendGetMobileEmail } from '@/pages/api/scribeAPIV2';
import { type GetMobileRequest } from '@/types';
import { toast } from '@heidi/design-system/toast';
import { useTranslations } from '@heidi/runtime/i18n';
import { useMutation } from '@tanstack/react-query';

export function useMutateSendGetMobileEmail() {
  const { t } = useTranslations();

  return useMutation({
    mutationFn: async (variables: GetMobileRequest) => {
      await sendGetMobileEmail(variables);
    },
    onSuccess: () => {
      toast({
        title: t('mobileAppModal.emailSent'),
        tone: 'success',
      });
    },
    onError: () => {
      toast({
        title: t('mobileAppModal.emailError'),
        tone: 'destructive',
      });
    },
  });
}
